<template>
  <!-- AI F §1.3.2 — an address, an optional display name and the crawl scope -->
  <div class="p-8">
    <woot-modal-header
      :header-title="$t('KNOWLEDGE_BASE.URL.TITLE')"
      :header-content="$t('KNOWLEDGE_BASE.URL.DESC')"
    />

    <form class="mt-4" @submit.prevent="submit">
      <label>
        {{ $t('KNOWLEDGE_BASE.URL.ADDRESS') }}
        <input v-model="url" type="url" placeholder="https://example.com/help" />
      </label>

      <label>
        {{ $t('KNOWLEDGE_BASE.URL.NAME') }}
        <input v-model="name" type="text" />
      </label>

      <!-- AI F §1.3.2 — single page or the whole domain, the latter capped by depth and the page limit -->
      <fieldset class="mb-4">
        <legend class="text-sm font-medium mb-1">
          {{ $t('KNOWLEDGE_BASE.URL.SCOPE') }}
        </legend>
        <label v-for="option in scopes" :key="option" class="flex items-center gap-2 font-normal">
          <input v-model="scope" type="radio" :value="option" class="!mb-0" />
          <span class="text-sm">
            {{ $t(`KNOWLEDGE_BASE.URL.SCOPES.${option.toUpperCase()}`) }}
          </span>
        </label>
      </fieldset>

      <p v-if="scope === 'domain'" class="text-xs text-slate-500 mb-4">
        {{ $t('KNOWLEDGE_BASE.URL.DOMAIN_HINT') }}
      </p>

      <div class="flex justify-end gap-2">
        <woot-button variant="clear" @click.prevent="$emit('close')">
          {{ $t('KNOWLEDGE_BASE.URL.CANCEL') }}
        </woot-button>
        <woot-button
          type="submit"
          :is-loading="isSaving"
          :is-disabled="!url.trim() || isSaving"
        >
          {{ $t('KNOWLEDGE_BASE.URL.SAVE') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return { url: '', name: '', scope: 'page', scopes: ['page', 'domain'], isSaving: false };
  },
  methods: {
    async submit() {
      this.isSaving = true;
      try {
        await this.$store.dispatch('kbSources/create', {
          source_type: 'website_url',
          name: this.name.trim(),
          settings: { url: this.url.trim(), scope: this.scope },
        });
        this.showAlert(this.$t('KNOWLEDGE_BASE.URL.STARTED'));
        this.$emit('close');
      } catch (error) {
        // AI F §1.3.5 — the server sends the FRD wording, show it as is
        this.showAlert(
          error?.response?.data?.error || this.$t('KNOWLEDGE_BASE.URL.ERROR')
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
